<div class="fixed-left fixed-bottom-whatsapp" (click)="openChat()">
  <a class="circle-btn whatsapp">
    <i class="fa fa-whatsapp"></i>
  </a>
</div>

<ng-container *ngIf="isChatOpen">
  <div class="chat-message">
    <div class="header p-3 d-flex align-items-center">
      <div class="">
        <p class="m-0 text-white">{{ stationName }} {{ stationFrecuency }}</p>
      </div>
    </div>
  
    <div class="message px-3 py-2">
      <div class="received-message mb-3">
        <div class="message-bubble">
          {{ sentMessage }}
        </div>
      </div>
      <div class="sent-message mb-3">
        <div class="message-bubble">
          ...
        </div>
      </div>
    </div>
  
    <div class="footer p-3 d-flex text-center" (click)="goWhatsApp()">
      <div class="me-2">
        <button class="btn btn-light">
          Contactar
        </button>
      </div>
      <button class="btn btn-success">
        <i class="fa fa-paper-plane"></i>
      </button>
    </div>
  </div>
  
</ng-container>
